module.exports = __webpack_public_path__ + "static/media/career-1.e383aa7f.png";